<template>
	<div>
		<a-modal v-show='!ishand' id='getdown' width='23rem' v-model="visible" on-ok="handleOk1"
			v-dragModal class='myfus'
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-lisp'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 100%;">登出</div>
				
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="border-radius: 0 0 10px 10px;" :style='{height: "11rem"}'>
				<div style="padding-top: 1.5rem;">
					<div style="text-align: center;margin: 2rem 0;font-size: 1rem;">
						確定要登出
						</div>
					<div style="text-align: center;">
						<button class='btn1 btnx' @click="$router.go(-1)">確定</button>
						<button class='btn1 btn2' @click='handleCancel'>取消</button>
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: ['openstatic'],
		data() {
			return {
				england: 'cn',
				visible: true,
				ishand: false,
				rules: {},
				form: {
					entryfee: '1',
					a4: '',
					plates_cn: '1',
					a3: '',
					a2: '',
					a1: '1',
				},
				admintypeArr: [{
					text: 'HKEX',
					value: '1'
				}, ],
			}
		},
		methods: {
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>
<style lang='scss' scoped>
	.mark-lisp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;

		div {
			text-align: center;
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	.warp_width {
		width: 9rem;
	}

	.btn1 {
		width: 5rem;
		height: 2rem;
		font-size: .8rem;
		color: #fff;
		border: 0;
		border-radius: 5px;
		margin: 0 1.5rem;
	}

	.btnx {
		background-color: #2a83dd;
	}

	.btn2 {
		background-color: #c2c2c2;
	}
</style>
<style lang="scss">
	#getdown {
		.ant-modal {
			top: 30vh;
		}
		.ant-modal-close-x{
			.anticon svg{
				color:#5cb1b9;
				position: relative;
				top: .8rem
			}
		}
		
		.my-right{
			text-align:right;
		}
		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: 1rem !important;
		}
		.ant-input{
			font-size: 1rem !important;
		}
		.ant-select-selection-selected-value {
			font-size: 1rem !important;
		}

		.ant-form-item-children {
			font-size: 1rem !important;
		}


		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}



		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
